import { useTheme } from "@shared/primitive-components"

type LogoVariants = "white" | "black" | "brand"

interface LogoProps extends React.SVGAttributes<SVGElement> {
  variant?: LogoVariants
}

export const Logo = ({ variant, ...rest }: LogoProps) => {
  const theme = useTheme()
  switch (variant) {
    case `brand`:
      return <LogoSVG fill={theme.palette.brand} {...rest} />
    case `white`:
      return <LogoSVG fill={theme.palette.white} {...rest} />
    case `black`:
    default:
      return <LogoSVG fill={theme.palette.coal.dark} {...rest} />
  }
}

interface Props {
  fill: string
}

const LogoSVG = ({ fill, ...props }: React.SVGAttributes<SVGElement> & Props) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1666 281.8"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path
        fill={fill}
        d="M974.7,0.6c-74.7,0-135.3,62.9-135.3,140.6c0,77.6,60.6,140.6,135.3,140.6c74.7,0,135.3-62.9,135.3-140.6
			C1110,63.5,1049.4,0.6,974.7,0.6z M974.7,219.1c-41.5,0-75.1-34.9-75.1-78c0-43.1,33.6-78,75.1-78c41.5,0,75.1,34.9,75.1,78
			C1049.7,184.2,1016.1,219.1,974.7,219.1z"
      />
      <path fill={fill} d="M822.4,213.5l-98.8,0c-6.1,0-11-4.9-11-11V6.8h-59.9v266.9l169.7,0V213.5z" />
      <path
        fill={fill}
        d="M1542.9,139.5l95.2-132.8h-65.8l-87.8,112.4c-2,2.6-6.2,1.2-6.2-2.2V6.8h-59.9l0,266.9h59.9l0-109.4
			c0-3.2,3.9-4.7,6-2.4l104.7,111.8h74.5L1542.9,139.5z"
      />
      <path
        fill={fill}
        d="M585,110.2h-91.9c-3.4,0-6.1-2.7-6.1-6.1V73.1c0-3.4,2.7-6.1,6.1-6.1h127.4l0-60.2c0,0-193.4,0-193.4,0
			l0,266.9H487l0-103.4l98,0.1V110.2z"
      />
      <path
        fill={fill}
        d="M1346.5,182.6c-4.8-2.6-10.7-1.1-13.7,3.4c-13.6,20.2-36.1,33.3-61.6,33.3c-41.6,0-75.2-35-75.2-78.1
			c0-43.2,33.7-78.1,75.2-78.1c25.5,0,48,13.2,61.6,33.3c3,4.5,9,6,13.7,3.4l44.3-24.3c-22.7-44.5-67.8-74.8-119.7-74.8
			c-74.8,0-135.4,62.9-135.4,140.6c0,77.6,60.6,140.6,135.4,140.6c51.9,0,96.9-30.3,119.7-74.8L1346.5,182.6z"
      />
      <path
        fill={fill}
        d="M248.6,0h-62.2L280,128.7c5,6.9,5,16.3,0,23.2l-62.8,86.4h-31.1l62.8-86.4c5-6.9,5-16.3,0-23.2L155.4,0H0
			l101.9,140.2L0,280.5h62.2l93.5-128.6c5-6.9,5-16.3,0-23.2L92.8,42.2h31.1l62.8,86.4c5,6.9,5,16.3,0,23.2L93.2,280.5h155.4
			l101.9-140.2L248.6,0z"
      />
    </g>
  </svg>
)

Logo.defaultProps = {
  variant: `black`,
}
